<template>
  <div class>
    <v-toolbar dark color="primary">
      <v-toolbar-title>
        <v-icon class="icon">fa-plus</v-icon>Add Test
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn fab small class="close" @click="closePanel">
        <v-icon dark>fa-times</v-icon>
      </v-btn>
    </v-toolbar>
    <v-container>
      <v-row>
        <v-col md="12">
          <v-form>
            <v-text-field
              :error-messages="messages.name"
              v-model="test.name"
              label="Test Name"
              type="text"
            ></v-text-field>
          </v-form>
        </v-col>
      </v-row>
    </v-container>
    <v-footer absolute height="68">
      <v-flex px-4 py-4 text-right>
        <v-btn v-if="!s3Uploading" color="primary" @click="closePanel">Cancel</v-btn>
        <v-btn v-if="s3Uploading" color="primary" loading></v-btn>
        <v-btn v-else color="primary" class="ml-2" @click="addCourse">Create Test</v-btn>
      </v-flex>
    </v-footer>
  </div>
</template>
<script>
import { EventBus } from "@/event-bus.js";
import courseAPI from "@/api/course.js";
export default {
  name: "CreateTest",
  components: {},
  props: {
    id: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      test: {},
      messages: {}
    };
  },
  computed: {},
  mounted() {},
  methods: {
    closePanel() {
      this.$emit("closePanel");
    },
    addTest() {
      this.loading = true;
    }
  }
};
</script>
